export const formatPrice = (price = 0, currency = 'EUR') => {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency }).format(price)
}